import { createLogic } from "redux-logic";
import * as ActionTypes from "../../actions/actionTypes";
import * as controlPanelActions from "../../actions/controlPanelActions";

const createExperienceFailLogic = createLogic({
	type: ActionTypes.CREATE_EXPERIENCE_FAIL,
	latest: true,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		dispatch(controlPanelActions.displayError(action.errorMessage.message));
		done();
	},
});

export default [createExperienceFailLogic];
